<template>
	<div class="configuration">
		<div class="left-configuration">
			<div class="exe-config">客户端:{{ wsState === false ? '连接失败,检查[配置]是否勾选' : '√' }}</div>
			<el-menu :default-active="activeTab" @select="handleSelectTab" class="el-menu-vertical-demo">
				<el-menu-item index="title"><i class="iconfont iconbiaotianniu"></i><span slot="title">标题定位</span></el-menu-item>
				<el-menu-item index="lack"><i class="iconfont iconbiaotianniu"></i><span slot="title">缺考</span></el-menu-item>
				<el-menu-item index="examNo"><i class="iconfont iconshengchengkaohaoicon"></i><span slot="title">考号区域</span></el-menu-item>
				<el-menu-item index="objective" v-show="tempObjTabState"><i class="iconfont iconkeguanti"></i><span slot="title">客观题</span></el-menu-item>
				<el-menu-item index="subjective" v-show="tempSubTabState"><i class="iconfont iconzhuguanti"></i><span slot="title">主观题</span></el-menu-item>
				<el-menu-item index="choose" v-show="chooseTabState"><i class="iconfont iconzhuguanti"></i><span slot="title">选做题</span></el-menu-item>
				<el-menu-item index="slice" v-if="tempOriginFlag"><i class="iconfont iconzhuguanti"></i><span slot="title">原卷切块</span></el-menu-item>
			</el-menu>
			<temp-select-refer />
		</div>
		<div class="center-configuration" ref="centerConf"><centerConf /></div>
		<div class="right-configuration"><right-conf :activeTab="activeTab" @viewOriginalPage="viewOriginalPage" /></div>
		<chose-template />
		<page-preview v-if="pagePreviewState" />
		<temp-right-key />
		<temp-adjust-coordinate />
		<div class="portal-des" v-show="handleState"><portal-target name="ope-dialog"></portal-target></div>
		<portal-target name="fix-temp"></portal-target>
		<div class="equip-state" v-show="tempReferTabState">设置参考模板中...</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import cookies from '@/utils/cookie'
import { initWS, openWs, errorWS } from './utils/js/websockets'
export default {
	name: 'home',
	components: {
		centerConf: () => import('./component/center-configuration'),
		rightConf: () => import('./component/right-configuration'),
		choseTemplate: () => import('./component/chose-template'),
		pagePreview: () => import('../../components/page-preview'),
		tempRightKey: () => import('./component/temp-right-key'),
		tempAdjustCoordinate: () => import('./component/temp-adjust-coordinate'),
		tempSelectRefer: () => import('./component/temp-selected-refer')
	},
	data() {
		return {
			//no use
			referState: null,
			//题型  默认是题号
			activeTab: 'title',
			// 预览
			pagePreviewState: false,
			//ws 链接状态
			wsState: false,
			//ws
			sockets: '',
			//是否完成阅卷
			isOver: false,
			//考号和选择题 手动配置弹窗站台
			handleState: false,
			//no use
			dialogTableVisible: true
		}
	},
	watch: {
		handleSliceOriginClick(val) {
			this.isOver = val.state
			this.handleSelectTab('slice', false)
		},
		handHandleState: {
			handler(val) {
				this.handleState = val
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'tempReferTabState',
			'groupListDetail',
			'tempObjTabState',
			'tempSubTabState',
			'chooseTabState',
			'tempOriginFlag',
			'handHandleState',
			'handleSliceOriginClick'
		])
	},
	created() {
		this.$screenRation()
		const query = this.$route.query
		cookies.set('socketsKey', new Date().getTime())
		cookies.set('token', query.token)
		cookies.set('uuid', 'userId-' + query.userId)
		this.del({ dbName: 'database', path: 'tempReferArea', delKey: '', user: true })
		this.del({ dbName: 'database', path: 'tempReferTabState', delKey: '', user: true })
		this.del({ dbName: 'database', path: 'tempObjSelTemp', delKey: '', user: true })
		this.del({ dbName: 'database', path: 'tempExamNoSelRefer', delKey: '', user: true })
		this.del({ dbName: 'database', path: 'tempObjSelRefer', delKey: '', user: true })
		this.del({ dbName: 'database', path: 'tempObjTopic', delKey: '', user: true })
	},
	mounted() {
		document.title = '模板配置-云阅卷'
		document.oncontextmenu = () => false
		window.addEventListener('resize', () => {
			window.location.reload()
		})
		const _this = this
		this.$refs['centerConf'].addEventListener('scroll', function(e) {
			_this.setTempScrollTop(e.target.scrollTop)
			_this.setTempScrollLeft(e.target.scrollLeft)
		})
		this.websocketState()
	},
	methods: {
		...mapActions('examination/databases', ['del']),
		...mapMutations('examination/configation', [
			'setTabActive',
			'setTempScrollTop',
			'setTempScrollLeft',
			'setTempOriginFlag',
			'setTempReferTabState',
			'setTempScalePage',
			'setWsState'
		]),
		//ws
		websocketState() {
			const _this = this
			this.sockets = initWS()
			openWs(this.sockets, () => {
				_this.wsState = true
				_this.setWsState(true)
			})
			errorWS(this.sockets, () => {
				_this.wsState = false
				_this.setWsState(false)
			})
		},
		// 切换tab
		handleSelectTab(key, flag = true) {
			if (this.isOver && flag) {
				this.$message.error('已完成阅卷，不可操作')
				return false
			}
			this.activeTab = key
			this.setTabActive(key)
			this.setTempReferTabState(false)
			this.del({ dbName: 'database', path: 'tempExamNoSelRefer', delKey: '', user: true })
			this.del({ dbName: 'database', path: 'tempObjSelRefer', delKey: '', user: true })
		},
		// 查看原图
		viewOriginalPage() {
			this.pagePreviewState = true
		}
	}
}
</script>

<style scoped lang="less">
.configuration {
	width: 100%;
	height: 100%;
	position: relative;
	background: #cbeade;
	.portal-des {
		position: fixed;
		width: 100vw;
		height: 100vh;
		background: red;
		z-index: 10;
	}

	.left-configuration {
		height: 100%;
		width: 90px;
		padding-top: 10px;
		box-sizing: border-box;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		background: white;
		/deep/ .el-menu {
			border-right: none;
		}
		/deep/.el-menu-item {
			padding: 0 5px;
		}
		/deep/.is-active .iconfont {
			font-weight: bolder;
		}
		.iconfont {
			font-size: 12px;
			margin-right: 8px;
		}
		.exe-config {
			font-weight: bold;
			font-size: 14px;
			padding: 5px 3px;
			width: 92%;
			border-radius: 5px;
			margin-bottom: 5px;
			background-color: #ffb800;
			color: white;
			text-align: center;
		}
	}
	.center-configuration {
		position: absolute;
		top: 0;
		left: 93px;
		height: 100%;
		width: calc(100% - 255px);
		overflow: auto;
	}
	/deep/.el-menu-item {
		padding-left: 5px !important;
	}
	/deep/.is-active {
		color: #006157 !important;
		font-weight: bolder;
	}
	.right-configuration {
		height: 100%;
		width: 160px;
		position: absolute;
		top: 0;
		right: 0;
		background: white;
		z-index: 10;
	}
	.state {
		position: absolute;
		padding: 5px 15px;
		box-sizing: border-box;
		background: #ff6f1b;
		border-radius: 5px;
		color: white;
		&:hover {
			cursor: pointer;
		}
	}
	.state-sus {
		background: #009688;
	}
	.equip-state {
		position: fixed;
		top: 0;
		left: 90px;
		background: #009688;
		border-radius: 6px;
		z-index: 50;
		padding: 5px 20px 7px 10px;
		color: white;
	}
}
</style>
